import { AppstoreOutlined } from '@ant-design/icons';
import type { NavigationItemType } from '~/types/navigation';

export default {
    id: 'group-warehouse',
    type: 'group',
    title: 'Skladište',
    children: [{
        id: 'warehouse-zones',
        type: 'item',
        url: '/wms/zones',
        icon: AppstoreOutlined,
        title: 'Skladišne zone',
    }],
} as NavigationItemType;
